import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { collection, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/config';

export default function NotificationCenter() {
  const { user } = useAuth();
  const [dossiers, setDossiers] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedDossier, setSelectedDossier] = useState('');
  const [recipients, setRecipients] = useState({
    client: '',
    superadmin: '',
    projectmanager: '',
    'charge-affaire': ''
  });
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dossierSnap = await getDocs(collection(db, 'dossiers'));
        const userSnap = await getDocs(collection(db, 'users'));

        const dossiersList = dossierSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const usersList = userSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        setDossiers(dossiersList);
        setUsers(usersList);
      } catch (err) {
        console.error('Erreur chargement Firestore:', err);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    const selectedUsers = Object.values(recipients).filter(Boolean);
    if (!selectedDossier || selectedUsers.length === 0 || !message.trim()) {
      setError("Tous les champs sont obligatoires.");
      return;
    }

    try {
      await addDoc(collection(db, 'notifications'), {
        title: 'Nouvelle notification',
        message,
        relatedId: selectedDossier,
        participants: selectedUsers,
        createdAt: serverTimestamp(),
        createdBy: user.uid,
        readBy: [],
        replies: [],
        attachments: [],
      });
      setSuccess(true);
      setError('');
      setSelectedDossier('');
      setRecipients({ client: '', superadmin: '', projectmanager: '', 'charge-affaire': '' });
      setMessage('');
    } catch (err) {
      console.error('Erreur création notification:', err);
      setError("Échec de création de la notification.");
    }
  };

  const roles = ['client', 'superadmin', 'projectmanager', 'charge-affaire'];

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-xl font-bold mb-4">Créer une notification</h2>

      {success && <div className="text-green-600 mb-4">Notification créée avec succès.</div>}
      {error && <div className="text-red-600 mb-4">{error}</div>}

      <div className="mb-4">
        <label className="block font-semibold mb-1">Dossier :</label>
        <select
          value={selectedDossier}
          onChange={(e) => setSelectedDossier(e.target.value)}
          className="w-full border p-2 rounded"
        >
          <option value="">-- Sélectionner un dossier --</option>
          {dossiers.map((d) => (
            <option key={d.id} value={d.id}>
              {d.clientName || d.dossierNumber || d.id}
            </option>
          ))}
        </select>
      </div>

      {roles.map((role) => (
        <div key={role} className="mb-4">
          <label className="block font-semibold mb-1">Destinataire ({role}) :</label>
          <select
            value={recipients[role] || ''}
            onChange={(e) => setRecipients(prev => ({ ...prev, [role]: e.target.value }))}
            className="w-full border p-2 rounded"
          >
            <option value="">-- Choisir un {role} --</option>
            {users.filter(u => u.role === role).map(u => (
              <option key={u.id} value={u.id}>
                {u.displayName || u.email}
              </option>
            ))}
          </select>
        </div>
      ))}

      <div className="mb-4">
        <label className="block font-semibold mb-1">Message :</label>
        <textarea
          className="w-full border p-2 rounded"
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Votre message..."
        />
      </div>

      <button
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Envoyer la notification
      </button>
    </div>
  );
}
